import { render, staticRenderFns } from "./RxField.vue?vue&type=template&id=324aa02f"
import script from "./RxField.vue?vue&type=script&lang=js"
export * from "./RxField.vue?vue&type=script&lang=js"
import style0 from "./RxField.vue?vue&type=style&index=0&id=324aa02f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports